import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const AdminDashboard = () => {
    const { session, isTableAdmin } = useAuth();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/stats`, {
                    headers: { Authorization: `Bearer ${session}` }
                });
                if (response.data.success) {
                    setStats(response.data.stats);
                }
            } catch (error) {
                console.error('Failed to fetch admin stats:', error);
            } finally {
                setLoading(false);
            }
        };

        if (isTableAdmin) {
            fetchStats();
        }
    }, [session, isTableAdmin]);

    if (!isTableAdmin) {
        return <div className="p-8 text-center text-red-500">Access Denied: Admin Only</div>;
    }

    if (loading) return <div className="p-8 text-center">Loading Stats...</div>;

    return (
        <div className="p-8 bg-dark-bg text-dark-text-primary min-h-screen">
            <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="p-6 bg-dark-surface border border-dark-border rounded-lg shadow-sm">
                    <h3 className="text-dark-text-secondary text-sm font-medium">Total Users</h3>
                    <p className="text-2xl font-bold mt-2">{stats?.totalUsers?.[0]?.count || 0}</p>
                </div>
                <div className="p-6 bg-dark-surface border border-dark-border rounded-lg shadow-sm">
                    <h3 className="text-dark-text-secondary text-sm font-medium">Workflows Created</h3>
                    <p className="text-2xl font-bold mt-2">{stats?.totalWorkflows?.[0]?.count || 0}</p>
                </div>
                <div className="p-6 bg-dark-surface border border-dark-border rounded-lg shadow-sm">
                    <h3 className="text-dark-text-secondary text-sm font-medium">Active Subscriptions</h3>
                    <p className="text-2xl font-bold mt-2">{stats?.activeSubscriptions?.[0]?.count || 0}</p>
                </div>
            </div>

            <div className="bg-dark-surface border border-dark-border rounded-lg shadow-sm overflow-hidden">
                <div className="px-6 py-4 border-b border-dark-border">
                    <h2 className="text-lg font-semibold">Recent Activity</h2>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm">
                        <thead className="bg-dark-bg text-dark-text-secondary uppercase text-xs">
                            <tr>
                                <th className="px-6 py-3">Action</th>
                                <th className="px-6 py-3">User ID</th>
                                <th className="px-6 py-3">Timestamp</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-dark-border">
                            {stats?.recentActivity?.map((log) => (
                                <tr key={log.id} className="hover:bg-dark-bg transition">
                                    <td className="px-6 py-4 font-medium">{log.action}</td>
                                    <td className="px-6 py-4 text-dark-text-secondary">{log.user_id}</td>
                                    <td className="px-6 py-4 text-dark-text-secondary">{new Date(log.timestamp).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
